import { Heading } from '@ksyos/design-system';
import { TextInputFormGroup } from '../../processActivityFormGroupFields';

export function TpoFlexGradingEdit(): JSX.Element {
    return (
        <>
            <Heading size="medium">Beoordeling</Heading>
            <TextInputFormGroup
                fieldKey="grading"
                isRequired={true}
                label="Beoordeling"
            />
        </>
    );
}
